<template>
  <footer class="bg-gray-900 text-white">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <!-- Основной контент footer -->
      <div class="py-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        <!-- Колонка 1: О платформе -->
        <div class="lg:col-span-1">
          <div class="flex items-center space-x-2 mb-4">
            <img 
              src="@/assets/tenzr_logo_site.png" 
              alt="Tenzr Logo" 
              class="w-10 h-10 object-contain"
            />
            <span class="text-xl font-bold">Tenzr</span>
          </div>
          <p class="text-gray-300 text-sm leading-relaxed mb-6">
            Unified interface for LLMs. Получите доступ к лучшим языковым моделям через единый API с возможностью оплаты российскими картами.
          </p>
          <!-- Социальные сети -->
          <div class="flex space-x-4">
            <a
              href="#"
              class="text-gray-400 hover:text-white transition-colors"
              aria-label="Twitter"
            >
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a
              href="#"
              class="text-gray-400 hover:text-white transition-colors"
              aria-label="LinkedIn"
            >
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z" clip-rule="evenodd"/>
              </svg>
            </a>
            <a
              href="#"
              class="text-gray-400 hover:text-white transition-colors"
              aria-label="GitHub"
            >
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z" clip-rule="evenodd"/>
              </svg>
            </a>
            <a
              href="#"
              class="text-gray-400 hover:text-white transition-colors"
              aria-label="Telegram"
            >
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
              </svg>
            </a>
          </div>
        </div>

        <!-- Колонка 2: Продукт -->
        <div>
          <h3 class="text-lg font-semibold mb-4">Продукт</h3>
          <ul class="space-y-2 text-sm">
            <li>
              <router-link to="/models" class="text-gray-300 hover:text-white transition-colors">
                Каталог моделей
              </router-link>
            </li>
            <li>
              <router-link to="/chat" class="text-gray-300 hover:text-white transition-colors">
                AI Chat
              </router-link>
            </li>
            <li>
              <router-link to="/rankings" class="text-gray-300 hover:text-white transition-colors">
                Рейтинги
              </router-link>
            </li>
            <li>
              <a href="#" class="text-gray-300 hover:text-white transition-colors">
                API
              </a>
            </li>
            <li>
              <a href="#" class="text-gray-300 hover:text-white transition-colors">
                Pricing
              </a>
            </li>
          </ul>
        </div>

        <!-- Колонка 3: Ресурсы -->
        <div>
          <h3 class="text-lg font-semibold mb-4">Ресурсы</h3>
          <ul class="space-y-2 text-sm">
            <li>
              <router-link to="/docs" class="text-gray-300 hover:text-white transition-colors">
                Документация
              </router-link>
            </li>
            <li>
              <a href="#" class="text-gray-300 hover:text-white transition-colors">
                Блог
              </a>
            </li>
            <li>
              <a href="#" class="text-gray-300 hover:text-white transition-colors">
                Руководства
              </a>
            </li>
            <li>
              <a href="#" class="text-gray-300 hover:text-white transition-colors">
                Поддержка
              </a>
            </li>
            <li>
              <a href="#" class="text-gray-300 hover:text-white transition-colors">
                Статус системы
              </a>
            </li>
          </ul>
        </div>

        <!-- Колонка 4: Компания -->
        <div>
          <h3 class="text-lg font-semibold mb-4">Компания</h3>
          <ul class="space-y-2 text-sm">
            <li>
              <a href="#" class="text-gray-300 hover:text-white transition-colors">
                О нас
              </a>
            </li>
            <li>
              <a href="#" class="text-gray-300 hover:text-white transition-colors">
                Карьера
              </a>
            </li>
            <li>
              <a href="#" class="text-gray-300 hover:text-white transition-colors">
                Контакты
              </a>
            </li>
            <li>
              <a href="#" class="text-gray-300 hover:text-white transition-colors">
                Пресса
              </a>
            </li>
            <li>
              <a href="#" class="text-gray-300 hover:text-white transition-colors">
                Партнеры
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Разделитель -->
      <div class="border-t border-gray-800 py-6">
        <div class="md:flex md:items-center md:justify-between">
          <!-- Левая часть: Копирайт -->
          <div class="text-sm text-gray-400">
            <p>&copy; {{ currentYear }} Tenzr. Все права защищены.</p>
          </div>

          <!-- Правая часть: Юридические ссылки -->
          <div class="mt-4 md:mt-0">
            <ul class="flex flex-wrap items-center space-x-6 text-sm text-gray-400">
              <li>
                <a href="#" class="hover:text-white transition-colors">
                  Политика конфиденциальности
                </a>
              </li>
              <li>
                <a href="#" class="hover:text-white transition-colors">
                  Условия использования
                </a>
              </li>
              <li>
                <a href="#" class="hover:text-white transition-colors">
                  Cookies
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Дополнительная информация для российских пользователей -->
      <div class="border-t border-gray-800 py-4">
        <div class="text-center text-xs text-gray-500">
          <p>
            Платформа поддерживает оплату российскими банковскими картами.
            Все транзакции проходят через защищенные каналы связи.
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

// Вычисляем текущий год для копирайта
const currentYear = computed(() => new Date().getFullYear())
</script> 